import React from "react";
import { useTranslation } from "react-i18next";
import DishImage from "../DishImage";
import Price from "../Price";
import Stepper from "../Stepper";

/**
 * One dish on the order. A dish still in the cart has a quantity stepper and opens for
 * editing; a dish already sent to the kitchen is shown as sent and cannot change.
 */
const OrderLine = ({ item, imageUrl, onChangeQuantity, onEdit }) => {
  const { t } = useTranslation();
  const name = item?.translations?.name || item?.name;
  const sent = item.readOnly || item.isOrderSubmitted;
  const details = [
    ...(item.cookingLevel || []),
    ...(item.removeIngredients || []),
    ...(item.notes ? [item.notes] : []),
    ...(item.serverNotes ? [item.serverNotes] : []),
  ].join(" · ");
  const editable = !sent && item.options?.length > 0 && onEdit;

  const body = (
    <>
      <span className="text-sm font-bold text-dark">{name}</span>
      {details && <span className="text-xs text-muted">{details}</span>}
      <Price value={item.price} className="text-sm font-bold text-primary" />
    </>
  );

  return (
    <div className="flex items-center gap-3 px-3 py-2.5 rounded-lg bg-surface shadow-soft">
      <div className="w-16 h-16 flex-none rounded-md bg-[#FBF6F6] flex items-center justify-center">
        <DishImage src={imageUrl} alt="" seed={item.menu_item_id ?? name} size={54} />
      </div>
      {editable ? (
        <button
          type="button"
          onClick={() => onEdit(item)}
          className="flex-1 min-w-0 flex flex-col gap-0.5 text-start"
        >
          {body}
        </button>
      ) : (
        <div className="flex-1 min-w-0 flex flex-col gap-0.5">{body}</div>
      )}
      {sent ? (
        <div className="flex flex-col items-end gap-0.5 text-xs text-muted">
          <span className="px-2 py-0.5 rounded-sm bg-secondary font-medium">{t("sentToKitchen")}</span>
          <span className="tabular-nums">×{item.quantity ?? 1}</span>
        </div>
      ) : (
        <Stepper
          size="sm"
          value={item.quantity ?? 1}
          onDecrease={() => onChangeQuantity(item, -1)}
          onIncrease={() => onChangeQuantity(item, 1)}
        />
      )}
    </div>
  );
};

export default OrderLine;
